import { Info } from '@carboledger/ui/icons';
import styles from './InfoLabel.module.scss';

// TODO: give the glyph a real explanation once @carboledger/ui ships a Tooltip.

/**
 * Props:
 *   children  the label text the glyph trails
 */
export const InfoLabel = ({ children }) => (
  <span className={styles.label}>
    {children}
    <Info size={14} className={styles.icon} aria-hidden="true" />
  </span>
);
